import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../shared/components/header/header.component';
import { FooterComponent } from '../shared/components/footer/footer.component';
import { environment } from 'src/environments/environment';
import { GetCountryDataService } from 'src/shared/services/get-country-data.service';
import { CommonModule } from '@angular/common';
import {
    TranslateDirective,
    TranslatePipe,
    TranslateService,
} from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
        RouterOutlet,
        HeaderComponent,
        FooterComponent,
        CommonModule,
        TranslateDirective,
        TranslatePipe,
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
    hideHeaderAndFooter = false;
    getCountryData = inject(GetCountryDataService);
    private translate = inject(TranslateService);

    constructor() {
        this.translate.addLangs(['en', 'es', 'zh']);
        this.translate.setFallbackLang('es');
        this.translate.use('es');
    }
    async ngOnInit() {
        // this.getCountryData.saveDataWithOutLogin();
        // await this.initializeApp();
        // this.hideHeaderAndFooter =
        this.hideHeaderAndFooter = (environment as any).hideHeaderAndFooter
            ? (environment as any).hideHeaderAndFooter
            : false;
        environment.lastLanguage = 'es';
        environment.currentLanguage = 'es';
        window.addEventListener('message', (event) => {
            if (event.data?.type === 'change-lang') {
                let lang = event.data.lang;
                if (environment.currentLanguage === lang) return;
                environment.lastLanguage = environment.currentLanguage;
                environment.currentLanguage = lang;
                this.translate.use(lang);
            }
            if (event.data?.type === 'hide') {
                this.hideHeaderAndFooter = true;
            }
        });
    }
    async initializeApp() {
        if (environment.apigoogle) {
            const scriptEl = window.document.createElement('script');
            scriptEl.async = true;
            scriptEl.src =
                'https://maps.googleapis.com/maps/api/js?key=' +
                environment.apigoogle +
                `&libraries=places,marker,geometry&language=ES&region=GT`;
            window.document.head.appendChild(scriptEl);
        }
    }
}
